/**
 * @description Run a script after DOM is loaded.
 * @param fn function to be executed.
 */
const scriptRunner = (fn: () => void) => {
  document.readyState === 'complete' ? fn() : window.addEventListener('load', fn)
}

export { scriptRunner }